module.exports = __webpack_public_path__ + "img/cabbage-posterized-small-alpha.0f8068e1.png";